"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatten = void 0;
var tslib_1 = require("tslib");
function flatten(arr) {
    var result = [];
    arr.forEach(function (item) {
        if (Array.isArray(item)) {
            result = tslib_1.__spread(result, flatten(item));
        }
        else {
            result.push(item);
        }
    });
    return result;
}
exports.flatten = flatten;
//# sourceMappingURL=flatten.js.map